import Immutable from 'seamless-immutable';
import * as actionTypes from './actionTypes';

const initialState = Immutable({
  byId: {},
  params: {},
  actionsloading: false
});

export function connHeaderReducer(state = initialState, action) {
  // console.log('in connHeaderReducer reduecer....', action)
  switch (action.type) {
    case actionTypes.SAVE_CONNECTION_HEADER:
    case actionTypes.UPDATE_CONNECTION_HEADER:
    case actionTypes.FETCH_CONNECTION_HEADERS:
    case actionTypes.DELETE_CONNECTION_HEADER:
      return {
        ...state,
        actionsloading: true
      }
    case actionTypes.FETCH_CONNECTION_HEADERS_SUCCESS:
      return {
        ...state,
        byId: action.payload.byId || {},
        actionsloading: false
      }
    case actionTypes.SAVE_CONNECTION_HEADER_SUCCESS:
    case actionTypes.UPDATE_CONNECTION_HEADER_SUCCESS:
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.connectionheaderUid]: action.payload
        },
        // byId: { ...state.byId, ...action.payload.byId },
        actionsloading: false
      }
    case actionTypes.DELETE_CONNECTION_HEADER_SUCCESS:
      Object.keys(state.byId).forEach(function (key, index) {
        console.log(key)
        if (state.byId[key].connectionheaderUid === action.payload.id) {
          console.log('match......', action.payload.id)
          delete state.byId[key]
        } else {
          console.log('33333')
        }
      })
      return {
        ...state,
        byId: state.byId,
        actionsloading: false
      }
    default:
      return state;
  }
}